// core
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// services
import { MemberValidationFlowService } from '../services/member-validation-flow.service';


@Component({
  selector: 'member-validation',
  templateUrl: './member-validation.component.html',
  styleUrls: ['./member-validation.component.scss']
})
export class MemberValidationComponent implements OnInit {
  formData!: any;

  constructor(
    private route: ActivatedRoute,
    public memberValidationFlowService: MemberValidationFlowService
  ) { }

  ngOnInit(): void {
    if (
      this.route.snapshot.data.customer &&
      this.route.snapshot.data.user
    ) {
      if (this.route.snapshot.data.customer.avios_member_number) {
        this.formData = this.memberValidationFlowService.getSecondStep(this.route.snapshot.data.customer);
      } else {
        this.formData = this.memberValidationFlowService.getFirstStep(this.route.snapshot.data.customer); 
      }
    }
  }
}
